module.exports = __webpack_public_path__ + "img/receipt_off_icon.de843c20.svg";